export const MAX_TOPIC_WORDS = 3;

export function countTopicWords(name: string): number {
  return name.trim().split(/\s+/).filter(Boolean).length;
}

export function isValidTopicName(name: string): boolean {
  const trimmed = name.trim();
  return trimmed.length > 0 && countTopicWords(trimmed) <= MAX_TOPIC_WORDS;
}

export function topicNameError(name: string): string | null {
  const trimmed = name.trim();
  if (!trimmed) return 'نام تاپیک الزامی است';
  const words = countTopicWords(trimmed);
  if (words > MAX_TOPIC_WORDS) {
    return `نام تاپیک حداکثر ${MAX_TOPIC_WORDS} کلمه باشد (${words} کلمه وارد شده)`;
  }
  return null;
}
